import React, { useState, useEffect } from 'react';
import { LoadingSpinner } from '../loading-spinner';
import { Text } from '../../foundations';
import styles from './LoadingOverlay.module.css';
import { useInterval } from '../../../helpers/hooks/useInterval';

export type LoadingOverlayProps = {
	title?: React.ReactNode;
	subtitles?: React.ReactNode[];
	textTransition?: number;
	isOpen: boolean;
};

export function LoadingOverlay({ title, subtitles = [], textTransition, isOpen }: LoadingOverlayProps) {
	const [subtitleIndex, setSubtitleIndex] = useState(0);

	const { stop: stopInterval, reset: resetInteval } = useInterval({
		callback: () => {
			setSubtitleIndex((prevState) => {
				const next = prevState + 1;
				if (next < subtitles.length) {
					return next;
				} else {
					stopInterval();
				}
				return prevState;
			});
		},
		intervalTime: textTransition
	});

	useEffect(() => {
		if (isOpen) {
			setSubtitleIndex(0);
			subtitles.length > 0 && resetInteval();
		} else {
			stopInterval();
		}
	}, [isOpen, subtitles]);

	if (!isOpen) {
		return null;
	}

	return (
		<div className={styles.overlay}>
			<div className={styles.content}>
				<LoadingSpinner size="extra-big">
					{title && (
						<Text as="h1" font="iberia-headline" size="xl-regular" className={styles.title}>
							{title}
						</Text>
					)}
					{subtitles.length > 0 && (
						<>
							<hr className={styles.divider} />
							<Text as="p" font="iberia-headline" size="md-bold" className={styles.subtitle}>
								{subtitles[subtitleIndex]}
							</Text>
						</>
					)}
				</LoadingSpinner>
			</div>
		</div>
	);
}
